import moment from "moment";

import PayoutStatus from "../utils/PayoutStatus";

const timeline = [
  { side: "left", title: "Login", desc: "User created account" },
  { side: "right", title: "Investment Added", desc: "₹10,000 added" },
  { side: "left", title: "KYC Completed", desc: "Verified identity" },
  { side: "right", title: "First Withdrawal", desc: "₹2,000 withdrawn" }
];

const Timeline = ({ timeLineData }) => {
  return (
    <div className="timeline">
      <div className="line" />
      {timeLineData.map((item, i) => {
        const { id, side, dateTime, type, label, tokens, productName, userName, amount, status } = item
        const readable = moment(dateTime);
        const date = readable.format("DD/MM/YYYY");
        const time = readable.format("hh:mm:ss A");


        const readableDateTime = `${readable.format("DD/MM/YYYY")}\n${readable.format("HH:mm:ss")}`;
        return (
          <div key={id} className={`timeline-item ${side}`}>
            <div className="content">
              <div className="fw-600 mb-1">{label}</div>

              {type === 'userReferred' && (
                <div className="mb-1">
                  <span className="fw-600">User name</span>: {userName}
                </div>
              )}

              {productName && (
                <div className="mb-1">
                  <label className="fw-500">Product:</label>
                  <span className="ml-1">{productName}</span>
                </div>
              )}

              {tokens && (
                <div className="mb-1">
                  <label className="fw-500">Tokens:</label>
                  <span className="ml-2">{tokens}</span>
                </div>
              )}

              {amount && (
                <div className="mb-1">
                  <label className="fw-500">Amount:</label>
                  <span className="ml-2">₹{amount}</span>
                </div>
              )}

              {status && (
                <div className="mb-1">
                  <span className=""><PayoutStatus status={status} /></span>
                </div>
              )}

              <div className="text-muted fw-500" style={{fontSize: 13}}>{date}</div>
              <div className="text-muted fw-500" style={{fontSize: 13}}>{time}</div>
            </div>
          </div>
        )

      }
      )}
    </div>
  )
}

export default Timeline
